import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { APIResponseWrapper } from '../../models/common/api-response-wrapper';
import { CrmDashboardOverview } from './crm-dashboard.model';

@Injectable({ providedIn: 'root' })
export class CrmDashboardService {
  private readonly apiUrl = `${environment.restApiUrl}crm/dashboard`;

  constructor(private http: HttpClient) {}

  getOverview(params: HttpParams): Observable<CrmDashboardOverview> {
    return this.http
      .get<APIResponseWrapper<CrmDashboardOverview>>(`${this.apiUrl}/overview`, { params })
      .pipe(map(response => response?.data || {}));
  }
}
